import Cropper from "./components/Cropper";

const App = () => (
   <div className="app flex justify-center items-center">
      <Cropper />
   </div>
);

export default App;
